import { api } from '@/lib/api';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

export function useExportGroupSheet(groupId: string) {
  return useMutation({
    mutationFn: () => api.post<{ url: string; warning?: string }>(`/groups/${groupId}/export-sheet`, {}),
    onSuccess: ({ url, warning }) => {
      toast.success('Google Sheet aangemaakt', {
        description: warning ?? 'De sheet staat klaar in Google Drive.',
        action: {
          label: 'Openen',
          onClick: () => window.open(url, '_blank', 'noopener,noreferrer'),
        },
        duration: 10000,
      });
    },
    onError: (error: Error) => {
      toast.error(`Fout bij exporteren: ${error.message}`);
    },
  });
}
